module.exports = __webpack_public_path__ + "static/img/blog 1024x768.7cd9917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/blog/blog 1024x768.jpg
// module id = mwj+
// module chunks = 47